const GLOBAL_STUDY_SEARCH_FIELDS = [
  'studyInstanceUID',
  'patientName',
  'patientId',
  'studyDescription',
  'modalities',
  'accessionNumber',
  'sourceAE',
];

export const matchesStudyGlobalSearch = (study = {}, search = '') => {
  const needle = String(search ?? '').trim().toLowerCase();
  if (!needle) return true;
  return GLOBAL_STUDY_SEARCH_FIELDS
    .map(field => String(study[field] ?? ''))
    .join(' ')
    .toLowerCase()
    .includes(needle);
};
